module.exports = __webpack_public_path__ + "static/media/logo-facebook.e60830b3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo-facebook.svg
// module id = 551
// module chunks = 0